import React from "react"
import BaseIcon from "./BaseIcon"

const ArrowRight = ({ color, ...props }) => (
    <BaseIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.2678 18.5L26 9.48013L13.2678 0.5L12.0729 2.04967L23.3629 8.92384L0 8.48675V10.5132L23.2393 10.1159L12.0729 16.9503L13.2678 18.5Z"
            fill={color ? color : "#27272D"}
        />
    </BaseIcon>
)

export default ArrowRight
